export const __SITE_CONSTANTS__ = {
    devBaseUrl: "https://api-dev.smartpos.uz",
    prodBaseUrl: "https://api.smartpos.uz",
    baseUrl: "https://gateway-dev.smartpos.uz",
    lang: document.documentElement.getAttribute('lang'),
    langs: {
        RU: "ru-RU",
        UZ: "uz-UZ"
    }
};